import { render, staticRenderFns } from "./LockUser.vue?vue&type=template&id=59bf70e9"
import script from "./LockUser.vue?vue&type=script&lang=ts"
export * from "./LockUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports